import * as React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import Typography from "@mui/material/Typography";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { os22, os21Evento, leisure21, os20 } from "../Images";

const theme = createTheme({
    components: {
      MuiTypography: {
        styleOverrides: {
          root: {
            fontFamily: "Melbourne",
          },
        },
      },
    },
  });

export default function Collection() {
  const { state } = useLocation();
  const navigate = useNavigate();

  const onOpenModal = (item) => {
    window.open(item.img, "_self");
  };

  const contactButton = (e, title, look) => {
    e.stopPropagation();
    const message = encodeURIComponent(
      `Hi! I'm interested in ${title} from ${look}.`
    );
    const url = `https://wa.me/919004007226?text=${message}`;
    window.open(url, "_blank");
  };

  return (
    <ImageList sx={{ width: "100%", height: "100%" }} cols={state.row}>
      {itemData[state.type].map((item) => (
        <ThemeProvider theme={theme} key={item.img}>
          <ImageListItem
            sx={{
              position: "relative",
              cursor: "pointer",
              overflow: "hidden",
              "& img": {
                width: "100%",
                height: "auto",
                display: "block",
                transition: "transform 0.3s ease",
              },
              "&:hover img": {
                transform: "scale(1.05)", // zoom effect
              },
              "& .overlay": {
                opacity: 0,
                transform: "translateY(100%)",
                transition: "all 0.3s ease",
              },
              "&:hover .overlay": {
                opacity: 1,
                transform: "translateY(0)",
              },
              // Always visible on mobile
              "@media (max-width:768px)": {
                "& .overlay": {
                  opacity: 1,
                  transform: "translateY(0)",
                },
              },
            }}
            onClick={() => onOpenModal(item)}
          >
            <img
              src={`${item?.webpimg || item?.img}?auto=format`}
              srcSet={`${item?.webpimg || item?.img}?auto=format&dpr=2 2x`}
              alt={item.title}
              loading="lazy"
            />

            {/* Overlay */}
            <div
              className="overlay"
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
                height: "30%",
                minHeight: "60px",
                background:
                  "linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0))",
                color: "#fff",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "0.5em",
                boxSizing: "border-box",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "bold",
                  textAlign: "left-top",
                  fontSize: "clamp(0.7rem, 2vw, 1rem)",
                  lineHeight: 1.2,
                }}
              >
                {item.look}
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "clamp(0.7rem, 2vw, 1rem)",
                  lineHeight: 1.2,
                }}
              >
                {item.title}
              </Typography>
              <Button
                variant="contained"
                size="small"
                sx={{
                  mt: 0.5,
                  backgroundColor: "#010203",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#010203" },
                  fontSize: "clamp(0.65rem, 1.5vw, 0.85rem)",
                  padding: "0.25em 0.8em",
                  minHeight: "28px",
                }}
                onClick={(e) => contactButton(e, item.title, item.look)}
              >
                Get Details
              </Button>
            </div>
          </ImageListItem>
        </ThemeProvider>
      ))}
    </ImageList>
  );
}


const itemData = {
  os22: [
    {
      img: os22[1],
      webpimg: os22.w1,
      alt: "Double breasted honeycomb jacket",
      title: "Double breasted honeycomb jacket",
      look: "Look 1",
    },
    {
      img: os22[2],
      webpimg: os22.w2,
      alt: "Double breasted honeycomb jacket",
      title: "Double breasted honeycomb jacket",
      look: "Look 1",
    },
    {
      img: os22[3],
      webpimg: os22.w3,
      alt: "Double breasted honeycomb jacket",
      title: "Double-breasted BLAZER",
      look: "Look 1",
    },
    // {
    //   img: os22[4],
    //   webpimg: os22.w4,
    //   alt: "Double breasted honeycomb jacket",
    //   title: "Double-breasted BLAZER",
    //   look: "Look 1",
    // },

    {
      img: os22[5],
      webpimg: os22.w5,
      alt: "Grey double-breasted suit",
      title: "Grey double-breasted suit",
      look: "Look 2",
    },
    {
      img: os22[6],
      webpimg: os22.w6,
      alt: "Grey double-breasted suit",
      title: "Grey double-breasted suit",
      look: "Look 2",
    },
    {
      img: os22[7],
      webpimg: os22.w7,
      alt: "Grey double-breasted suit",
      title: "Grey double-breasted suit",
      look: "Look 2",
    },
    // {
    //   img: os22[8],
    //   webpimg: os22.w8,
    //   alt: "Grey double-breasted suit",
    //   title: "Grey double-breasted suit",
    //   look: "Look 2",
    // },

    {
      img: os22[9],
      webpimg: os22.w9,
      alt: "Orange corduroy suits",
      title: "Orange corduroy suits",
      look: "Look 3",
    },
    {
      img: os22[10],
      webpimg: os22.w10,
      alt: "Orange corduroy suits",
      title: "Orange corduroy suits",
      look: "Look 3",
    },
    {
      img: os22[11],
      webpimg: os22.w11,
      alt: "Corduroy suit",
      title: "Orange corduroy suits",
      look: "Look 3",
    },
    // {
    //   img: os22[12],
    //   webpimg: os22.w12,
    //   alt: "Corduroy suit",
    //   title: "Orange corduroy suits",
    //   look: "Look 3",
    // },

    {
      img: os22[13],
      webpimg: os22.w13,
      alt: "BABY BLUE DENIM SHIRT",
      title: "BABY BLUE DENIM SHIRT",
      look: "Look 4",
    },
    {
      img: os22[14],
      webpimg: os22.w14,
      alt: "BABY BLUE DENIM SHIRT",
      title: "BABY BLUE DENIM SHIRT",
      look: "Look 4",
    },
    {
      img: os22[15],
      webpimg: os22.w15,
      alt: "DENIM SHIRT",
      title: "BABY BLUE DENIM SHIRT",
      look: "Look 4",
    },
    // {
    //   img: os22[17],
    //   webpimg: os22.w17,
    //   alt: "DENIM SHIRT",
    //   title: "BABY BLUE DENIM SHIRT",
    //   look: "Look 4",
    // },

    {
      img: os22[18],
      webpimg: os22.w18,
      alt: "Orange corduroy suits",
      title: "Orange corduroy suits",
      look: "Look 5",
    },
    {
      img: os22[19],
      webpimg: os22.w19,
      alt: "Orange corduroy suits",
      title: "Orange corduroy suits",
      look: "Look 5",
    },
    {
      img: os22[20],
      webpimg: os22.w20,
      alt: "corduroy suits",
      title: "Orange corduroy suits",
      look: "Look 5",
    },
    // {
    //   img: os22[21],
    //   webpimg: os22.w21,
    //   alt: "corduroy suits",
    //   title: "Orange corduroy suits",
    //   look: "Look 5",
    // },

    {
      img: os22[22],
      webpimg: os22.w22,
      alt: "Velvet Bandhgala Jacket",
      title: "Velvet Bandhgala Jacket",
      look: "Look 6",
    },
    {
      img: os22[23],
      webpimg: os22.w23,
      alt: "Velvet Bandhgala Jacket",
      title: "Velvet Bandhgala Jacket",
      look: "Look 6",
    },
    {
      img: os22[24],
      webpimg: os22.w24,
      alt: "Velvet Bandhgala suit",

      title: "Velvet Bandhgala Jacket",
      look: "Look 6",
    },
    // {
    //   img: os22[25],
    //   webpimg: os22.w25,
    //   alt: "Velvet Bandhgala suit",
    //   title: "Velvet Bandhgala Jacket",
    //   look: "Look 6",
    // },
    {
      img: os22[26],
      webpimg: os22.w26,
      title: "Liquid velvet blazer",
      look: "Look 7",
    },
    {
      img: os22[27],
      webpimg: os22.w27,
      alt: "Velvet Bandhgala suit",
      title: "Liquid velvet blazer",
      look: "Look 7",
    },
    {
      img: os22[28],
      webpimg: os22.w28,
      alt: "Velvet evening jacket",
      title: "Liquid velvet blazer",
      look: "Look 7",
    },
    // {
    //   img: os22[29],
    //   webpimg: os22.w29,
    //   alt: "Velvet evening jacket",
    //   title: "Liquid velvet blazer",
    //   look: "Look 7",
    // },
    {
      img: os22[30],
      webpimg: os22.w30,
      alt: "Velvet evening jacket",
      title: "Velvet Bandhgala Jacket",
      look: "Look 8",
    },
    {
      img: os22[31],
      webpimg: os22.w31,
      alt: "Velvet evening jacket",
      title: "Velvet Bandhgala Jacket",
      look: "Look 8",
    },
    {
      img: os22[32],
      webpimg: os22.w32,
      alt: "Velvet Bandhgala suit",
      title: "Velvet Bandhgala Jacket",
      look: "Look 8",
    },

    // {
    //   img: os22[33],
    //   webpimg: os22.w33,
    //   alt: "Velvet Bandhgala suit",
    //   title: "Velvet Bandhgala Jacket",
    //   look: "Look 8",
    // },
    {
      img: os22[34],
      webpimg: os22.w34,
      alt: "Metallic suit",
      title: "Metallic suit jacket",
      look: "Look 9",
    },
    {
      img: os22[35],
      webpimg: os22.w35,
      alt: "Metallic suit",
      title: "Metallic suit jacket",
      look: "Look 9",
    },
    {
      img: os22[36],
      webpimg: os22.w36,
      alt: "Velvet Bandhgala suit",
      title: "Metallic suit jacket",
      look: "Look 9",
    },
    // {
    //   img: os22[37],
    //   webpimg: os22.w37,
    //   alt: "Velvet Bandhgala suit",
    //   title: "Metallic suit jacket",
    //   look: "Look 9",
    // },
    {
      img: os22[38],
      webpimg: os22.w38,
      alt: "007 tuxedo suit",
      title: "007 tuxedo suit",
      look: "Look 10",
    },
    {
      img: os22[39],
      webpimg: os22.w39,
      alt: "007 tuxedo suit",
      title: "007 tuxedo suit",
      look: "Look 10",
    },
    // {
    //   img: os22[40],
    //   webpimg: os22.w40,
    //   alt: "Classic tuxedo",
    //   title: "007 tuxedo suit",
    //   look: "Look 10",
    // },
    {
      img: os22[41],
      webpimg: os22.w41,
      alt: "Classic tuxedo",
      title: "007 tuxedo suit",
      look: "Look 10",
    },

    {
      img: os22[42],
      webpimg: os22.w42,
      alt: "Tuxedo shirt",
      title: "Tuxedo shirt",
      look: "Look 11",
    },
    {
      img: os22[43],
      webpimg: os22.w43,
      alt: "Tuxedo shirt",
      title: "Tuxedo shirt",
      look: "Look 11",
    },
    // {
    //   img: os22[44],
    //   webpimg: os22.w44,
    //   alt: "Wingtip tuxedo shirt",
    //   title: "Tuxedo shirt",
    //   look: "Look 11",
    // },
    {
      img: os22[45],
      webpimg: os22.w45,
      alt: "Wingtip tuxedo shirt",
      title: "Tuxedo shirt",
      look: "Look 11",
    },

    {
      img: os22[46],
      webpimg: os22.w46,
      alt: "Classic tuxedo",
      title: "007 tuxedo suit",
      look: "Look 12",
    },
    {
      img: os22[47],
      webpimg: os22.w47,
      alt: "Classic tuxedo",
      title: "007 tuxedo suit",
      look: "Look 12",
    },
    // {
    //   img: os22[48],
    //   webpimg: os22.w48,
    //   alt: "007 tuxedo suit",
    //   title: "007 tuxedo suit",
    //   look: "Look 12",
    // },
    {
      img: os22[49],
      webpimg: os22.w49,
      alt: "007 tuxedo suit",
      title: "007 tuxedo suit",
      look: "Look 12",
    },
    {
      img: os22[50],
      webpimg: os22.w50,
      alt: "Turquoise drawstring trouser",
      title: "Drawstring trousers",
      look: "Look 13",
    },
    {
      img: os22[51],
      webpimg: os22.w51,
      alt: "Turquoise drawstring trouser",
      title: "Drawstring trousers",
      look: "Look 13",
    },
    // {
    //   img: os22[52],
    //   webpimg: os22.w52,
    //   alt: "Tailored drawstring trousers",
    //   title: "Drawstring trousers",
    //   look: "Look 13",
    // },
    {
      img: os22[53],
      webpimg: os22.w53,
      alt: "Tailored drawstring trousers",
      title: "Drawstring trousers",
      look: "Look 13",
    },
    {
      img: os22[54],
      webpimg: os22.w54,
      alt: "Tailored drawstring trousers",
      title: "Sand Slub drawstring trouser",
      look: "Look 14",
    },
    {
      img: os22[55],
      webpimg: os22.w55,
      alt: "Tailored drawstring trousers",
      title: "Sand Slub drawstring trouser",
      look: "Look 14",
    },
    // {
    //   img: os22[56],
    //   webpimg: os22.w56,
    //   alt: "Tailored drawstring trousers",
    //   title: "Sand Slub drawstring trouser",
    //   look: "Look 14",
    // },
    {
      img: os22[57],
      webpimg: os22.w57,
      alt: "Tailored drawstring trousers",
      title: "Sand Slub drawstring trouser",
      look: "Look 14",
    },
  ],
  os21: [
    {
      img: os21Evento[1],
      webpimg: os21Evento.w1,
      alt: "Bandhgala Jacket",
      title: "Bandhgala Jacket",
      look: "Look 1",
    },
    {
      img: os21Evento[2],
      webpimg: os21Evento.w2,
      alt: "Double breasted honeycomb jacket",
      title: "Bandhgala Jacket",
      look: "Look 1",
    },
    {
      img: os21Evento[3],
      webpimg: os21Evento.w3,
      alt: "Jodhpuri jacket",
      title: "Bandhgala Jacket",
      look: "Look 1",
    },
    // {
    //   img: os21Evento[4],
    //   webpimg: os21Evento.w4,
    //   alt: "Jodhpuri jacket",
    //   title: "Bandhgala Jacket",
    //   look: "Look 1",
    // },

    {
      img: os21Evento[5],
      webpimg: os21Evento.w5,
      alt: "Velvet blazers",
      title: "Liquid velvet jacket",
      look: "Look 2",
    },
    {
      img: os21Evento[6],
      webpimg: os21Evento.w6,
      alt: "Velvet blazers",
      title: "Liquid velvet jacket",
      look: "Look 2",
    },
    {
      img: os21Evento[7],
      webpimg: os21Evento.w7,
      alt: "Velvet blazers",
      title: "Liquid velvet jacket",
      look: "Look 2",
    },
    // {
    //   img: os21Evento[8],
    //   webpimg: os21Evento.w8,
    //   alt: "Velvet blazers",
    //   title: "Liquid velvet jacket",
    //   look: "Look 2",
    // },

    {
      img: os21Evento[9],
      webpimg: os21Evento.w9,
      alt: "Velvet blazers",
      title: "Liquid velvet jacket",
      look: "Look 3",
    },
    {
      img: os21Evento[10],
      webpimg: os21Evento.w10,
      alt: "Velvet blazers",
      title: "Liquid velvet jacket",
      look: "Look 3",
    },
    {
      img: os21Evento[11],
      webpimg: os21Evento.w11,
      alt: "Velvet blazers",
      title: "Liquid velvet jacket",
      look: "Look 3",
    },
    // {
    //   img: os21Evento[12],
    //   webpimg: os21Evento.w12,
    //   alt: "Velvet blazers",
    //   title: "Liquid velvet jacket",
    //   look: "Look 3",
    // },

    {
      img: os21Evento[13],
      webpimg: os21Evento.w13,
      alt: "Cashmere overcoat",
      title: "Overcoat",
      look: "Look 4",
    },
    {
      img: os21Evento[14],
      webpimg: os21Evento.w14,
      alt: "Cashmere overcoat",
      title: "Overcoat",
      look: "Look 4",
    },
    {
      img: os21Evento[15],
      webpimg: os21Evento.w15,
      alt: "Cashmere overcoat",
      title: "Overcoat",
      look: "Look 4",
    },
    // {
    //   img: os21Evento[16],
    //   webpimg: os21Evento.w16,
    //   alt: "Cashmere overcoat",
    //   title: "Overcoat",
    //   look: "Look 4",
    // },

    {
      img: os21Evento[17],
      webpimg: os21Evento.w17,
      alt: "Cashmere overcoat",
      title: "Overcoat",
      look: "Look 5",
    },
    {
      img: os21Evento[18],
      webpimg: os21Evento.w18,
      alt: "Cashmere overcoat",
      title: "Overcoat",
      look: "Look 5",
    },
    {
      img: os21Evento[19],
      webpimg: os21Evento.w19,
      alt: "Cashmere overcoat",
      title: "Overcoat",
      look: "Look 5",
    },
    // {
    //   img: os21Evento[20],
    //   webpimg: os21Evento.w20,
    //   alt: "Cashmere overcoat",
    //   title: "Overcoat",
    //   look: "Look 5",
    // },
    {
      img: leisure21[1],
      alt: "Luxury tracksuits",
      title: "Luxury leisurewear",
      look: "Look 1",
    },
    {
      img: leisure21[2],
      alt: "Luxury tracksuits",
      title: "Luxury leisurewear",
      look: "Look 1",
    },
    {
      img: leisure21[3],
      alt: "Luxury tracksuits",
      title: "Luxury leisurewear",
      look: "Look 1",
    },
    {
      img: leisure21[5],
      alt: "Luxury tracksuits",
      title: "Luxury leisurewear",
      look: "Look 2",
    },
    {
      img: leisure21[6],
      alt: "Luxury tracksuits",
      title: "Luxury leisurewear",
      look: "Look 2",
    },
    {
      img: leisure21[7],
      alt: "Luxury tracksuits",
      title: "Luxury leisurewear",
      look: "Look 2",
    },
    {
      img: leisure21[9],
      alt: "Luxury tracksuits",
      title: "Luxury leisurewear",
      look: "Look 3",
    },
    {
      img: leisure21[10],
      alt: "Luxury tracksuits",
      title: "Luxury leisurewear",
      look: "Look 3",
    },
    {
      img: leisure21[11],
      alt: "Luxury tracksuits",
      title: "Luxury leisurewear",
      look: "Look 3",
    },

    {
      img: leisure21[13],
      alt: "Luxury tracksuits",
      title: "Luxury leisurewear",
      look: "Look 4",
    },
    {
      img: leisure21[14],
      alt: "Luxury tracksuits",
      title: "Luxury leisurewear",
      look: "Look 4",
    },
    {
      img: leisure21[15],
      alt: "Luxury tracksuits",
      title: "Luxury leisurewear",
      look: "Look 4",
    },
  
    {
      img: leisure21[17],
      alt: "Luxury tracksuits",
      title: "Luxury leisurewear",
      look: "Look 5",
    },
    {
      img: leisure21[18],
      alt: "Luxury tracksuits",
      title: "Luxury leisurewear",
      look: "Look 5",
    },
    {
      img: leisure21[19],
      alt: "Luxury tracksuits",
      title: "Luxury leisurewear",
      look: "Look 5",
    },
    // {
    //   img: leisure21[20],
    //   alt: "Luxury tracksuits",
    //   title: "Luxury leisurewear",
    //   look: "Look 5",
    // },
    {
      img: leisure21[21],
      alt: "Luxury tracksuits",
      title: "Luxury leisurewear",
      look: "Look 6",
    },
    {
      img: leisure21[22],
      alt: "Luxury tracksuits",
      title: "Luxury leisurewear",
      look: "Look 6",
    },
    {
      img: leisure21[23],
      alt: "Luxury tracksuits",
      title: "Luxury leisurewear",
      look: "Look 6",
    },
    // {
    //   img: leisure21[24],
    //   alt: "Luxury tracksuits",
    //   title: "Luxury leisurewear",
    //   look: "Look 6",
    // },
  ],
  os20: [
    {
      img: os20[1],
      alt: "Classic grey check suit",
      title: "Grey Prince of Wales check suit",
      look: "Look 1",
    },
    {
      img: os20[2],
      alt: "Classic grey check suit",
      title: "Grey Prince of Wales check suit",
      look: "Look 1",
    },
    {
      img: os20[3],
      alt: "Classic grey check suit",
      title: "Grey Prince of Wales check suit",
      look: "Look 1",
    },
    {
      img: os20[4],
      alt: "Double-breasted BLAZER",
      title: "Double breasted jacket",
      look: "Look 2",
    },

    {
      img: os20[5],
      alt: "Double-breasted BLAZER",
      title: "Double breasted jacket",
      look: "Look 2",
    },
    {
      img: os20[6],
      alt: "Double-breasted BLAZER",
      title: "Double breasted jacket",
      look: "Look 2",
    },
    {
      img: os20[7],
      alt: "Classic double-breasted suit",
      title: "Double-breasted (DB) suit",
      look: "Look 3",
    },
    {
      img: os20[8],
      alt: "Classic double-breasted suit",
      title: "Double-breasted (DB) suit",
      look: "Look 3",
    },

    {
      img: os20[9],
      alt: "Classic double-breasted suit",
      title: "Double-breasted (DB) suit",
      look: "Look 3",
    },
    {
      img: os20[10],
      alt: "Pin Stripe Blazer",
      title: "Pin Stripe Jacket",
      look: "Look 4",
    },
    {
      img: os20[11],
      alt: "Pin Stripe Blazer",
      title: "Pin Stripe Jacket",
      look: "Look 4",
    },
    {
      img: os20[12],
      alt: "Pin Stripe Blazer",
      title: "Pin Stripe Jacket",
      look: "Look 4",
    },

    {
      img: os20[13],
      alt: "Lapel Waistcoat",
      title: "Lapel Waistcoat",
      look: "Look 5",
    },
    {
      img: os20[14],
      alt: "Lapel Waistcoat",
      title: "Lapel Waistcoat",
      look: "Look 5",
    },
    {
      img: os20[15],
      alt: "Lapel Waistcoat",
      title: "Lapel Waistcoat",
      look: "Look 5",
    },
    {
      img: os20[16],
      alt: "Shirt Jacket",
      title: "Shirt Jacket",
      look: "Look 6",
    },

    {
      img: os20[17],
      alt: "Linen Shirt Jacket",
      title: "Shirt Jacket",
      look: "Look 6",
    },
    {
      img: os20[18],
      alt: "Linen Shirt Jacket",
      title: "Shirt Jacket",
      look: "Look 6",
    },
    {
      img: os20[19],
      alt: "Classic grey check suit",
      title: "Grey Prince of Wales check suit",
      look: "Look 7",
    },
    {
      img: os20[20],
      alt: "Classic grey check suit",
      title: "Grey Prince of Wales check suit",
      look: "Look 7",
    },
    {
      img: os20[21],
      alt: "Classic grey check suit",
      title: "Grey Prince of Wales check suit",
      look: "Look 7",
    },
    {
      img: os20[22],
      alt: "Evening Gilet Waistcoats",
      title: "Evening Waistcoat",
      look: "Look 8",
    },
    {
      img: os20[23],
      alt: "Evening Gilet Waistcoat",
      title: "Evening Waistcoat",
      look: "Look 8",
    },
    {
      img: os20[24],
      alt: "Evening Gilet Waistcoat",
      title: "Evening Waistcoat",
      look: "Look 8",
    },
    {
      img: os20[25],
      alt: "Classic tuxedo",
      title: "007 tuxedo suit",
      look: "Look 9",
    },
    {
      img: os20[26],
      alt: "Classic tuxedo",
      title: "007 tuxedo suit",
      look: "Look 9",
    },
    {
      img: os20[27],
      alt: "Classic tuxedo",
      title: "007 tuxedo suit",
      look: "Look 9",
    },
    {
      img: os20[28],
      alt: "Classic tuxedo",
      title: "007 tuxedo suit",
      look: "Look 10",
    },
    {
      img: os20[29],
      alt: "Classic tuxedo",
      title: "007 tuxedo suit",
      look: "Look 10",
    },
    {
      img: os20[30],
      alt: "Classic tuxedo",
      title: "007 tuxedo suit",
      look: "Look 10",
    },
    {
      img: os20[31],
      alt: "Classic tuxedo",
      title: "Classic tuxedo",
      look: "Look 11",
    },
    {
      img: os20[32],
      alt: "007 tuxedo suit",
      title: "Classic tuxedo",
      look: "Look 11",
    },
    {
      img: os20[33],
      alt: "Classic tuxedo",
      title: "Classic tuxedo",
      look: "Look 11",
    },
  ],
 os24 : [
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/1+CLOUDY+GREY+FLANNEL+BLAZER/OS-BY-OS-25-SEPTEMBER-20241208.webp",
    alt: "CLOUDY GREY FLANNEL BLAZER",
    title: "CLOUDY GREY FLANNEL BLAZER",
    look: "Look 1",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/1+CLOUDY+GREY+FLANNEL+BLAZER/OS-BY-OS-25-SEPTEMBER-20241142.webp",
    alt: "CLOUDY GREY FLANNEL BLAZER",
    title: "CLOUDY GREY FLANNEL BLAZER",
    look: "Look 1",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/1+CLOUDY+GREY+FLANNEL+BLAZER/OS-BY-OS-25-SEPTEMBER-20241145.webp",
    alt: "CLOUDY GREY FLANNEL BLAZER",
    title: "CLOUDY GREY FLANNEL BLAZER",
    look: "Look 1",
  },

  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/2+GREEN+FLANNEL+BLAZER/OS-BY-OS-25-SEPTEMBER-20241307-1.webp",
    alt: "GREEN FLANNEL BLAZER",
    title: "GREEN FLANNEL BLAZER",
    look: "Look 2",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/2+GREEN+FLANNEL+BLAZER/OS-BY-OS-25-SEPTEMBER-20241371-1.webp",
    alt: "GREEN FLANNEL BLAZER",
    title: "GREEN FLANNEL BLAZER",
    look: "Look 2",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/2+GREEN+FLANNEL+BLAZER/OS-BY-OS-25-SEPTEMBER-20241416-1.webp",
    alt: "GREEN FLANNEL BLAZER",
    title: "GREEN FLANNEL BLAZER",
    look: "Look 2",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/3+WHITE+HONEYCOMB+BLAZER/OS-BY-OS-25-SEPTEMBER-20244272.webp",
    alt: "WHITE HONEYCOMB BLAZER",
    title: "WHITE HONEYCOMB BLAZER",
    look: "Look 3",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/3+WHITE+HONEYCOMB+BLAZER/OS-BY-OS-25-SEPTEMBER-20244279.webp",
    alt: "WHITE HONEYCOMB BLAZER",
    title: "WHITE HONEYCOMB BLAZER",
    look: "Look 3",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/3+WHITE+HONEYCOMB+BLAZER/OS-BY-OS-25-SEPTEMBER-20244356.webp",
    alt: "WHITE HONEYCOMB BLAZER",
    title: "WHITE HONEYCOMB BLAZER",
    look: "Look 3",
  },

  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/4+NAVY+BLUE+DB+BLAZER/OS-BY-OS-25-SEPTEMBER-20245468.webp",
    alt: "NAVY BLUE DB BLAZER",
    title: "NAVY BLUE DB BLAZER",
    look: "Look 4",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/4+NAVY+BLUE+DB+BLAZER/OS-BY-OS-25-SEPTEMBER-20245468.webp",
    alt: "NAVY BLUE DB BLAZER",
    title: "NAVY BLUE DB BLAZER",
    look: "Look 4",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/4+NAVY+BLUE+DB+BLAZER/OS-BY-OS-25-SEPTEMBER-20245468.webp",
    alt: "NAVY BLUE DB BLAZER",
    title: "NAVY BLUE DB BLAZER",
    look: "Look 4",
  },

  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/5+CHOC+BROWN+4+WAY+STRETCH+SUIT/OS-BY-OS-25-SEPTEMBER-20243628.webp",
    alt: "CHOC BROWN 4 WAY STRETCH SUIT",
    title: "CHOC BROWN 4 WAY STRETCH SUIT",
    look: "Look 5",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/5+CHOC+BROWN+4+WAY+STRETCH+SUIT/OS-BY-OS-25-SEPTEMBER-20243669.webp",
    alt: "CHOC BROWN 4 WAY STRETCH SUIT",
    title: "CHOC BROWN 4 WAY STRETCH SUIT",
    look: "Look 5",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/5+CHOC+BROWN+4+WAY+STRETCH+SUIT/OS-BY-OS-25-SEPTEMBER-20243726.webp",
    alt: "CHOC BROWN 4 WAY STRETCH SUIT",
    title: "CHOC BROWN 4 WAY STRETCH SUIT",
    look: "Look 5",
  },

  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/6+NAVY+BLUE+PARKA+JACKET/OS-BY-OS-25-SEPTEMBER-20243835.webp",
    alt: "NAVY BLUE PARKA JACKET",
    title: "NAVY BLUE PARKA JACKET",
    look: "Look 6",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/6+NAVY+BLUE+PARKA+JACKET/OS-BY-OS-25-SEPTEMBER-20243906.webp",
    alt: "NAVY BLUE PARKA JACKET",
    title: "NAVY BLUE PARKA JACKET",
    look: "Look 6",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/6+NAVY+BLUE+PARKA+JACKET/OS-BY-OS-25-SEPTEMBER-20243961.webp",
    alt: "NAVY BLUE PARKA JACKET",
    title: "NAVY BLUE PARKA JACKET",
    look: "Look 6",
  },

  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/7+NAVY+BLUE+FORMAL+SUIT/OS-BY-OS-25-SEPTEMBER-20245060.webp",
    alt: "NAVY BLUE FORMAL SUIT",
    title: "NAVY BLUE FORMAL SUIT",
    look: "Look 7",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/7+NAVY+BLUE+FORMAL+SUIT/OS-BY-OS-25-SEPTEMBER-20245092.webp",
    alt: "NAVY BLUE FORMAL SUIT",
    title: "NAVY BLUE FORMAL SUIT",
    look: "Look 7",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/7+NAVY+BLUE+FORMAL+SUIT/OS-BY-OS-25-SEPTEMBER-20245114.webp",
    alt: "NAVY BLUE FORMAL SUIT",
    title: "NAVY BLUE FORMAL SUIT",
    look: "Look 7",
  },

  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/8+DOUBLE+BLACK+FORMAL+SUIT/OS-BY-OS-25-SEPTEMBER-20246190.webp",
    alt: "DOUBLE BLACK FORMAL SUIT",
    title: "DOUBLE BLACK FORMAL SUIT",
    look: "Look 8",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/8+DOUBLE+BLACK+FORMAL+SUIT/OS-BY-OS-25-SEPTEMBER-20246245.webp",
    alt: "DOUBLE BLACK FORMAL SUIT",
    title: "DOUBLE BLACK FORMAL SUIT",
    look: "Look 8",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/8+DOUBLE+BLACK+FORMAL+SUIT/OS-BY-OS-25-SEPTEMBER-20246260.webp",
    alt: "DOUBLE BLACK FORMAL SUIT",
    title: "DOUBLE BLACK FORMAL SUIT",
    look: "Look 8",
  },

  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/9+BORDEUX+FORMAL+SUIT/OS-BY-OS-25-SEPTEMBER-20247374.webp",
    alt: "BORDEUX FORMAL SUIT",
    title: "BORDEUX FORMAL SUIT",
    look: "Look 9",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/9+BORDEUX+FORMAL+SUIT/OS-BY-OS-25-SEPTEMBER-20247403.webp",
    alt: "BORDEUX FORMAL SUIT",
    title: "BORDEUX FORMAL SUIT",
    look: "Look 9",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/9+BORDEUX+FORMAL+SUIT/OS-BY-OS-25-SEPTEMBER-20247427.webp",
    alt: "BORDEUX FORMAL SUIT",
    title: "BORDEUX FORMAL SUIT",
    look: "Look 9",
  },

  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/10+GREY+LOUNGE+CO-ORD+SET/OS-BY-OS-25-SEPTEMBER-20248510.webp",
    alt: "GREY LOUNGE CO-ORD SET",
    title: "GREY LOUNGE CO-ORD SET",
    look: "Look 10",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/10+GREY+LOUNGE+CO-ORD+SET/OS-BY-OS-25-SEPTEMBER-20248579.webp",
    alt: "GREY LOUNGE CO-ORD SET",
    title: "GREY LOUNGE CO-ORD SET",
    look: "Look 10",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/10+GREY+LOUNGE+CO-ORD+SET/OS-BY-OS-25-SEPTEMBER-20248696.webp",
    alt: "GREY LOUNGE CO-ORD SET",
    title: "GREY LOUNGE CO-ORD SET",
    look: "Look 10",
  },

  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/11+NAVY+BLUE+LOUNGE+CO-ORD+SET/OS-BY-OS-25-SEPTEMBER-20240841.webp",
    alt: "NAVY BLUE LOUNGE CO-ORD SET",
    title: "NAVY BLUE LOUNGE CO-ORD SET",
    look: "Look 11",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/11+NAVY+BLUE+LOUNGE+CO-ORD+SET/OS-BY-OS-25-SEPTEMBER-20240924.webp",
    alt: "NAVY BLUE LOUNGE CO-ORD SET",
    title: "NAVY BLUE LOUNGE CO-ORD SET",
    look: "Look 11",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS+24/11+NAVY+BLUE+LOUNGE+CO-ORD+SET/OS-BY-OS-25-SEPTEMBER-20240984.webp",
    alt: "NAVY BLUE LOUNGE CO-ORD SET",
    title: "NAVY BLUE LOUNGE CO-ORD SET",
    look: "Look 11",
  },
     // 1 TANGERINE VELVET JACKET
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/1 TANGERINE VELVET JACKET/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20244120.JPG",
  alt: "TANGERINE VELVET JACKET",
  title: "TANGERINE VELVET JACKET",
  look: "Look 1",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/1 TANGERINE VELVET JACKET/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20244152.JPG",
  alt: "TANGERINE VELVET JACKET",
  title: "TANGERINE VELVET JACKET",
  look: "Look 1",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/1 TANGERINE VELVET JACKET/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20244164.JPG",
  alt: "TANGERINE VELVET JACKET",
  title: "TANGERINE VELVET JACKET",
  look: "Look 1",
},

// 10 METTALLIC GREY JAQUARD SHERWANI
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/10 METTALLIC GREY JAQUARD SHERWANI/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20241309.JPG",
  alt: "METTALLIC GREY JAQUARD SHERWANI",
  title: "METTALLIC GREY JAQUARD SHERWANI",
  look: "Look 10",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/10 METTALLIC GREY JAQUARD SHERWANI/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20241326.JPG",
  alt: "METTALLIC GREY JAQUARD SHERWANI",
  title: "METTALLIC GREY JAQUARD SHERWANI",
  look: "Look 10",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/10 METTALLIC GREY JAQUARD SHERWANI/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20241379.JPG",
  alt: "METTALLIC GREY JAQUARD SHERWANI",
  title: "METTALLIC GREY JAQUARD SHERWANI",
  look: "Look 10",
},

// 11 CLASSIC BLACK ACHKAN
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/11 CLASSIC BLACK ACHKAN/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20240174.jpg",
  alt: "CLASSIC BLACK ACHKAN",
  title: "CLASSIC BLACK ACHKAN",
  look: "Look 11",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/11 CLASSIC BLACK ACHKAN/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20240257.jpg",
  alt: "CLASSIC BLACK ACHKAN",
  title: "CLASSIC BLACK ACHKAN",
  look: "Look 11",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/11 CLASSIC BLACK ACHKAN/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20240260.jpg",
  alt: "CLASSIC BLACK ACHKAN",
  title: "CLASSIC BLACK ACHKAN",
  look: "Look 11",
},

// 12 METALLIC BLASK SHINE SHIRT
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/12 METALLIC BLASK SHINE SHIRT/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20242612.jpg",
  alt: "METALLIC BLASK SHINE SHIRT",
  title: "METALLIC BLASK SHINE SHIRT",
  look: "Look 12",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/12 METALLIC BLASK SHINE SHIRT/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20242625.jpg",
  alt: "METALLIC BLASK SHINE SHIRT",
  title: "METALLIC BLASK SHINE SHIRT",
  look: "Look 12",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/12 METALLIC BLASK SHINE SHIRT/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20242640.jpg",
  alt: "METALLIC BLASK SHINE SHIRT",
  title: "METALLIC BLASK SHINE SHIRT",
  look: "Look 12",
},

// 13 SILK CO-ORD SET
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/13 SILK CO-ORD SET/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20242493.jpg",
  alt: "SILK CO-ORD SET",
  title: "SILK CO-ORD SET",
  look: "Look 13",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/13 SILK CO-ORD SET/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20242499.JPG",
  alt: "SILK CO-ORD SET",
  title: "SILK CO-ORD SET",
  look: "Look 13",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/13 SILK CO-ORD SET/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20242530.JPG",
  alt: "SILK CO-ORD SET",
  title: "SILK CO-ORD SET",
  look: "Look 13",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/13 SILK CO-ORD SET/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20242555.JPG",
  alt: "SILK CO-ORD SET",
  title: "SILK CO-ORD SET",
  look: "Look 13",
},

// 2 METALLIC SILVER JAQUARD JACKET
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/2 METALLIC SILVER JAQUARD JACKET/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20245317.JPG",
  alt: "METALLIC SILVER JAQUARD JACKET",
  title: "METALLIC SILVER JAQUARD JACKET",
  look: "Look 2",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/2 METALLIC SILVER JAQUARD JACKET/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20245363.JPG",
  alt: "METALLIC SILVER JAQUARD JACKET",
  title: "METALLIC SILVER JAQUARD JACKET",
  look: "Look 2",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/2 METALLIC SILVER JAQUARD JACKET/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20245370.JPG",
  alt: "METALLIC SILVER JAQUARD JACKET",
  title: "METALLIC SILVER JAQUARD JACKET",
  look: "Look 2",
},

// 3 RIPPLE BROWN JACKET
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/3 RIPPLE BROWN JACKET/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20244246.JPG",
  alt: "RIPPLE BROWN JACKET",
  title: "RIPPLE BROWN JACKET",
  look: "Look 3",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/3 RIPPLE BROWN JACKET/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20244254.JPG",
  alt: "RIPPLE BROWN JACKET",
  title: "RIPPLE BROWN JACKET",
  look: "Look 3",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/3 RIPPLE BROWN JACKET/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20244261.JPG",
  alt: "RIPPLE BROWN JACKET",
  title: "RIPPLE BROWN JACKET",
  look: "Look 3",
},

// 4 BROWN CAMO VELVER BLAZER
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/4 BROWN CAMO VELVER BLAZER/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20246674.jpg",
  alt: "BROWN CAMO VELVER BLAZER",
  title: "BROWN CAMO VELVER BLAZER",
  look: "Look 4",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/4 BROWN CAMO VELVER BLAZER/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20246688.jpg",
  alt: "BROWN CAMO VELVER BLAZER",
  title: "BROWN CAMO VELVER BLAZER",
  look: "Look 4",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/4 BROWN CAMO VELVER BLAZER/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20246712.jpg",
  alt: "BROWN CAMO VELVER BLAZER",
  title: "BROWN CAMO VELVER BLAZER",
  look: "Look 4",
},

// 5 CELESTIAL SPARKLE JACKET
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/5 CELESTIAL SPARKLE JACKET/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20245415.jpg",
  alt: "CELESTIAL SPARKLE JACKET",
  title: "CELESTIAL SPARKLE JACKET",
  look: "Look 5",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/5 CELESTIAL SPARKLE JACKET/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20245461.jpg",
  alt: "CELESTIAL SPARKLE JACKET",
  title: "CELESTIAL SPARKLE JACKET",
  look: "Look 5",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/5 CELESTIAL SPARKLE JACKET/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20245487.jpg",
  alt: "CELESTIAL SPARKLE JACKET",
  title: "CELESTIAL SPARKLE JACKET",
  look: "Look 5",
},

// 6 CLASSIC BLUE TUXEDO
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/6 CLASSIC BLUE TUXEDO/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20248788.JPG",
  alt: "CLASSIC BLUE TUXEDO",
  title: "CLASSIC BLUE TUXEDO",
  look: "Look 6",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/6 CLASSIC BLUE TUXEDO/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20248810.JPG",
  alt: "CLASSIC BLUE TUXEDO",
  title: "CLASSIC BLUE TUXEDO",
  look: "Look 6",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/6 CLASSIC BLUE TUXEDO/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20248820.JPG",
  alt: "CLASSIC BLUE TUXEDO",
  title: "CLASSIC BLUE TUXEDO",
  look: "Look 6",
},

// 7 MOCHA BROWN BANDHGALA
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/7 MOCHA BROWN BANDHGALA/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20249046.jpg",
  alt: "MOCHA BROWN BANDHGALA",
  title: "MOCHA BROWN BANDHGALA",
  look: "Look 7",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/7 MOCHA BROWN BANDHGALA/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20249060.jpg",
  alt: "MOCHA BROWN BANDHGALA",
  title: "MOCHA BROWN BANDHGALA",
  look: "Look 7",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/7 MOCHA BROWN BANDHGALA/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20249134.jpg",
  alt: "MOCHA BROWN BANDHGALA",
  title: "MOCHA BROWN BANDHGALA",
  look: "Look 7",
},

// 8 BLUE VELVET BOMBER  JACKET
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/8 BLUE VELVET BOMBER  JACKET/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20246549.jpg",
  alt: "BLUE VELVET BOMBER  JACKET",
  title: "BLUE VELVET BOMBER  JACKET",
  look: "Look 8",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/8 BLUE VELVET BOMBER  JACKET/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20246593.jpg",
  alt: "BLUE VELVET BOMBER  JACKET",
  title: "BLUE VELVET BOMBER  JACKET",
  look: "Look 8",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/8 BLUE VELVET BOMBER  JACKET/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20246610.jpg",
  alt: "BLUE VELVET BOMBER  JACKET",
  title: "BLUE VELVET BOMBER  JACKET",
  look: "Look 8",
},

// 9 FORREST GREEN FLANNEL JACKET
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/9 FORREST GREEN FLANNEL JACKET/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20249003.jpg",
  alt: "FORREST GREEN FLANNEL JACKET",
  title: "FORREST GREEN FLANNEL JACKET",
  look: "Look 9",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/9 FORREST GREEN FLANNEL JACKET/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20249009.jpg",
  alt: "FORREST GREEN FLANNEL JACKET",
  title: "FORREST GREEN FLANNEL JACKET",
  look: "Look 9",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS 24 EVENTO/9 FORREST GREEN FLANNEL JACKET/OSBYOS NIGHT LOOKS 25 SEPTEMBER 20249029.jpg",
  alt: "FORREST GREEN FLANNEL JACKET",
  title: "FORREST GREEN FLANNEL JACKET",
  look: "Look 9",
},

],
  osss25:[// 1 VIOLET LILEN SHACKET
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/1 VIOLET LILEN SHACKET/CNA05262 copy.jpg",
  alt: "VIOLET LILEN SHACKET",
  title: "VIOLET LILEN SHACKET",
  look: "Look 1",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/1 VIOLET LILEN SHACKET/CNA05273 copy.jpg",
  alt: "VIOLET LILEN SHACKET",
  title: "VIOLET LILEN SHACKET",
  look: "Look 1",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/1 VIOLET LILEN SHACKET/CNA05281 copy.jpg",
  alt: "VIOLET LILEN SHACKET",
  title: "VIOLET LILEN SHACKET",
  look: "Look 1",
},

// 2 BLUE SEERSUCKER STRIPE SHACKET
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/2 BLUE SEERSUCKER STRIPE SHACKET/CNA04952 (1).jpg",
  alt: "BLUE SEERSUCKER STRIPE SHACKET",
  title: "BLUE SEERSUCKER STRIPE SHACKET",
  look: "Look 2",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/2 BLUE SEERSUCKER STRIPE SHACKET/CNA04958 (1).jpg",
  alt: "BLUE SEERSUCKER STRIPE SHACKET",
  title: "BLUE SEERSUCKER STRIPE SHACKET",
  look: "Look 2",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/2 BLUE SEERSUCKER STRIPE SHACKET/CNA04965.jpg",
  alt: "BLUE SEERSUCKER STRIPE SHACKET",
  title: "BLUE SEERSUCKER STRIPE SHACKET",
  look: "Look 2",
},

// 3 BEIGE SHACKET
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/3 BEIGE SHACKET/CNA05119 copy.jpg",
  alt: "BEIGE SHACKET",
  title: "BEIGE SHACKET",
  look: "Look 3",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/3 BEIGE SHACKET/CNA05125.jpg",
  alt: "BEIGE SHACKET",
  title: "BEIGE SHACKET",
  look: "Look 3",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/3 BEIGE SHACKET/CNA05166 copy.jpg",
  alt: "BEIGE SHACKET",
  title: "BEIGE SHACKET",
  look: "Look 3",
},

// 4 SAGE GREEN SHACKET
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/4 SAGE GREEN SHACKET/CNA04985 (1).jpg",
  alt: "SAGE GREEN SHACKET",
  title: "SAGE GREEN SHACKET",
  look: "Look 4",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/4 SAGE GREEN SHACKET/CNA04995.jpg",
  alt: "SAGE GREEN SHACKET",
  title: "SAGE GREEN SHACKET",
  look: "Look 4",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/4 SAGE GREEN SHACKET/CNA05020.jpg",
  alt: "SAGE GREEN SHACKET",
  title: "SAGE GREEN SHACKET",
  look: "Look 4",
},

// 5 GREEN SEERSUCKER STRIPE ZIPPER JACKET
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/5 GREEN SEERSUCKER STRIPE ZIPPER JACKET/CNA04805.jpg",
  alt: "GREEN SEERSUCKER STRIPE ZIPPER JACKET",
  title: "GREEN SEERSUCKER STRIPE ZIPPER JACKET",
  look: "Look 5",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/5 GREEN SEERSUCKER STRIPE ZIPPER JACKET/CNA04808 (1).jpg",
  alt: "GREEN SEERSUCKER STRIPE ZIPPER JACKET",
  title: "GREEN SEERSUCKER STRIPE ZIPPER JACKET",
  look: "Look 5",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/5 GREEN SEERSUCKER STRIPE ZIPPER JACKET/CNA04813.jpg",
  alt: "GREEN SEERSUCKER STRIPE ZIPPER JACKET",
  title: "GREEN SEERSUCKER STRIPE ZIPPER JACKET",
  look: "Look 5",
},

// 6 BLUE CHECKS ZIPPER SHACKET
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS+SS25/6+BLUE+CHECKS++ZIPPER+SHACKET/CNA04685+(1).jpg",
  alt: "BLUE CHECKS ZIPPER SHACKET",
  title: "BLUE CHECKS ZIPPER SHACKET",
  look: "Look 6",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS+SS25/6+BLUE+CHECKS++ZIPPER+SHACKET/CNA04718.jpg",
  alt: "BLUE CHECKS ZIPPER SHACKET",
  title: "BLUE CHECKS ZIPPER SHACKET",
  look: "Look 6",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS+SS25/6+BLUE+CHECKS++ZIPPER+SHACKET/CNA04746.jpg",
  alt: "BLUE CHECKS ZIPPER SHACKET",
  title: "BLUE CHECKS ZIPPER SHACKET",
  look: "Look 6",
},

// 7 TAUPE SLEEVELESS ZIPPER JACKET
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/7 TAUPE SLEEVELESS ZIPPER JACKET/CNA05078.jpg",
  alt: "TAUPE SLEEVELESS ZIPPER JACKET",
  title: "TAUPE SLEEVELESS ZIPPER JACKET",
  look: "Look 7",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/7 TAUPE SLEEVELESS ZIPPER JACKET/CNA05088.jpg",
  alt: "TAUPE SLEEVELESS ZIPPER JACKET",
  title: "TAUPE SLEEVELESS ZIPPER JACKET",
  look: "Look 7",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/7 TAUPE SLEEVELESS ZIPPER JACKET/CNA05108.jpg",
  alt: "TAUPE SLEEVELESS ZIPPER JACKET",
  title: "TAUPE SLEEVELESS ZIPPER JACKET",
  look: "Look 7",
},

// 8 YELLOW LILEN SHIRT
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/8 YELLOW LILEN SHIRT/CNA05198.jpg",
  alt: "YELLOW LILEN SHIRT",
  title: "YELLOW LILEN SHIRT",
  look: "Look 8",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/8 YELLOW LILEN SHIRT/CNA05200 copy 2.jpg",
  alt: "YELLOW LILEN SHIRT",
  title: "YELLOW LILEN SHIRT",
  look: "Look 8",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/8 YELLOW LILEN SHIRT/CNA05210.jpg",
  alt: "YELLOW LILEN SHIRT",
  title: "YELLOW LILEN SHIRT",
  look: "Look 8",
},

// 9 BLACK PRINTED SHIRT
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/9 BLACK PRINTED SHIRT/CNA05696 copy.jpg",
  alt: "BLACK PRINTED SHIRT",
  title: "BLACK PRINTED SHIRT",
  look: "Look 9",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/9 BLACK PRINTED SHIRT/CNA05707 copy.jpg",
  alt: "BLACK PRINTED SHIRT",
  title: "BLACK PRINTED SHIRT",
  look: "Look 9",
},
{
  img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25/9 BLACK PRINTED SHIRT/CNA05709 copy.jpg",
  alt: "BLACK PRINTED SHIRT",
  title: "BLACK PRINTED SHIRT",
  look: "Look 9",
},
{
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/1 SUMMER GOLD LILEN SUIT/CNA05342-1.webp",
    alt: "SUMMER GOLD LILEN SUIT",
    title: "SUMMER GOLD LILEN SUIT",
    look: "Look 1",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/1 SUMMER GOLD LILEN SUIT/CNA05347.webp",
    alt: "SUMMER GOLD LILEN SUIT",
    title: "SUMMER GOLD LILEN SUIT",
    look: "Look 1",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/1 SUMMER GOLD LILEN SUIT/CNA05353-copy.webp",
    alt: "SUMMER GOLD LILEN SUIT",
    title: "SUMMER GOLD LILEN SUIT",
    look: "Look 1",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/10 BLUE COTTON BLAZER/CNA05642.webp",
    alt: "BLUE COTTON BLAZER",
    title: "BLUE COTTON BLAZER",
    look: "Look 10",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/10 BLUE COTTON BLAZER/CNA05646-copy.webp",
    alt: "BLUE COTTON BLAZER",
    title: "BLUE COTTON BLAZER",
    look: "Look 10",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/10 BLUE COTTON BLAZER/CNA05647-copy.webp",
    alt: "BLUE COTTON BLAZER",
    title: "BLUE COTTON BLAZER",
    look: "Look 10",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/11 BEIGE PIN STRIPES SUIT/CNA05610-copy.webp",
    alt: "BEIGE PIN STRIPES SUIT",
    title: "BEIGE PIN STRIPES SUIT",
    look: "Look 11",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/11 BEIGE PIN STRIPES SUIT/CNA05618-copy.webp",
    alt: "BEIGE PIN STRIPES SUIT",
    title: "BEIGE PIN STRIPES SUIT",
    look: "Look 11",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/11 BEIGE PIN STRIPES SUIT/CNA05620-copy.webp",
    alt: "BEIGE PIN STRIPES SUIT",
    title: "BEIGE PIN STRIPES SUIT",
    look: "Look 11",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/2 BROWN HERRINGBONE LILEN SUIT/CNA05378-copy.webp",
    alt: "BROWN HERRINGBONE LILEN SUIT",
    title: "BROWN HERRINGBONE LILEN SUIT",
    look: "Look 2",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/2 BROWN HERRINGBONE LILEN SUIT/CNA05392.webp",
    alt: "BROWN HERRINGBONE LILEN SUIT",
    title: "BROWN HERRINGBONE LILEN SUIT",
    look: "Look 2",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/2 BROWN HERRINGBONE LILEN SUIT/CNA05396.webp",
    alt: "BROWN HERRINGBONE LILEN SUIT",
    title: "BROWN HERRINGBONE LILEN SUIT",
    look: "Look 2",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/3 OVERSIZE BEIGE SUIT/CNA05416.webp",
    alt: "OVERSIZE BEIGE SUIT",
    title: "OVERSIZE BEIGE SUIT",
    look: "Look 3",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/3 OVERSIZE BEIGE SUIT/CNA05435.webp",
    alt: "OVERSIZE BEIGE SUIT",
    title: "OVERSIZE BEIGE SUIT",
    look: "Look 3",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/3 OVERSIZE BEIGE SUIT/CNA05446.webp",
    alt: "OVERSIZE BEIGE SUIT",
    title: "OVERSIZE BEIGE SUIT",
    look: "Look 3",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/4 COBALT BLUE CHECKS JACKET/CNA05491-copy.webp",
    alt: "COBALT BLUE CHECKS JACKET",
    title: "COBALT BLUE CHECKS JACKET",
    look: "Look 4",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/4 COBALT BLUE CHECKS JACKET/CNA05496-copy.webp",
    alt: "COBALT BLUE CHECKS JACKET",
    title: "COBALT BLUE CHECKS JACKET",
    look: "Look 4",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/4 COBALT BLUE CHECKS JACKET/CNA05505-copy.webp",
    alt: "COBALT BLUE CHECKS JACKET",
    title: "COBALT BLUE CHECKS JACKET",
    look: "Look 4",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/5 SEERSUCKER BLAZER/CNA05520-copy.webp",
    alt: "SEERSUCKER BLAZER",
    title: "SEERSUCKER BLAZER",
    look: "Look 5",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/5 SEERSUCKER BLAZER/CNA05528-copy.webp",
    alt: "SEERSUCKER BLAZER",
    title: "SEERSUCKER BLAZER",
    look: "Look 5",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/5 SEERSUCKER BLAZER/CNA05538-copy.webp",
    alt: "SEERSUCKER BLAZER",
    title: "SEERSUCKER BLAZER",
    look: "Look 5",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/6 BEIGE LILEN HANDMADE BANDHALA SUIT/CNA05550-copy.webp",
    alt: "BEIGE LILEN HANDMADE BANDHALA SUIT",
    title: "BEIGE LILEN HANDMADE BANDHALA SUIT",
    look: "Look 6",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/6 BEIGE LILEN HANDMADE BANDHALA SUIT/CNA05575-copy.webp",
    alt: "BEIGE LILEN HANDMADE BANDHALA SUIT",
    title: "BEIGE LILEN HANDMADE BANDHALA SUIT",
    look: "Look 6",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/6 BEIGE LILEN HANDMADE BANDHALA SUIT/CNA05587-copy.webp",
    alt: "BEIGE LILEN HANDMADE BANDHALA SUIT",
    title: "BEIGE LILEN HANDMADE BANDHALA SUIT",
    look: "Look 6",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/7 METALLIC SILVER DOUBLE BREASTED JACKET/CNA05694-copy.webp",
    alt: "METALLIC SILVER DOUBLE BREASTED JACKET",
    title: "METALLIC SILVER DOUBLE BREASTED JACKET",
    look: "Look 7",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/7 METALLIC SILVER DOUBLE BREASTED JACKET/CNA05713-copy.webp",
    alt: "METALLIC SILVER DOUBLE BREASTED JACKET",
    title: "METALLIC SILVER DOUBLE BREASTED JACKET",
    look: "Look 7",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/7 METALLIC SILVER DOUBLE BREASTED JACKET/CNA05716-copy.webp",
    alt: "METALLIC SILVER DOUBLE BREASTED JACKET",
    title: "METALLIC SILVER DOUBLE BREASTED JACKET",
    look: "Look 7",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/8 GREY & YELLOW REVERSIBLE JACKET/CNA05729 copy.jpg",
    alt: "GREY & YELLOW REVERSIBLE JACKET",
    title: "GREY & YELLOW REVERSIBLE JACKET",
    look: "Look 8",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/8 GREY & YELLOW REVERSIBLE JACKET/CNA05735 copy-optimized.webp",
    alt: "GREY & YELLOW REVERSIBLE JACKET",
    title: "GREY & YELLOW REVERSIBLE JACKET",
    look: "Look 8",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/8 GREY & YELLOW REVERSIBLE JACKET/CNA05738 copy-optimized.webp",
    alt: "GREY & YELLOW REVERSIBLE JACKET",
    title: "GREY & YELLOW REVERSIBLE JACKET",
    look: "Look 8",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/9 GREY & YELLOW REVERSIBLE JACKET/CNA05752-copy.webp",
    alt: "GREY & YELLOW REVERSIBLE JACKET",
    title: "GREY & YELLOW REVERSIBLE JACKET",
    look: "Look 9",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/9 GREY & YELLOW REVERSIBLE JACKET/CNA05759-copy.webp",
    alt: "GREY & YELLOW REVERSIBLE JACKET",
    title: "GREY & YELLOW REVERSIBLE JACKET",
    look: "Look 9",
  },
  {
    img: "https://d3lwdqji776yyc.cloudfront.net/OS SS25 EVENTO/9 GREY & YELLOW REVERSIBLE JACKET/CNA05763-copy.webp",
    alt: "GREY & YELLOW REVERSIBLE JACKET",
    title: "GREY & YELLOW REVERSIBLE JACKET",
    look: "Look 9",
  },
],
};
